export const en = {
  header: { title: "Sampling Session", samplingSession: "Sampling Session" },
  join: {
    joinSession: "Join session",
    enterSessionId: "Enter session ID",
    connecting: "Connecting to session…",
  },
  controls: {
    microphone: "Microphone",
    camera: "Camera",
    screenShareStart: "Share screen",
    screenShareStop: "Stop screen share",
    close: "Close",
    leave: "Hang up",
    notificationPlaceholder: "Notification...",
    notify: "Send",
    notificationInfo:
      "Show a notification, e.g. a PIN code, to the person being tested",
    sending: "Sending..",
    participants: "Participants",
    selectParticipantToDisconnect: "Select participant to disconnect",
    disconnecting: "Disconnecting...",
    disconnect: "Disconnect"
  },
  waitRoom: {
    title: "Wait room",
    admit: "Admit",
    admitting: "Admitting",
    dismiss: "Dismiss",
    dismissing: "Dismissing...",
    minimizedSingle: "1 participant in the wait room",
    minimizedMultiple: "{{count}} participants in the wait room",
  },
  status: { settingUp: "Setting up…" },
  errors: {
    genericError: "Something went wrong",
    tryAgainLater: "Try again later or contact support",
    noSuchSession: "No session found for that ID"
  },
} as const;
